import type { HTMLAttributes } from 'react'

export const FullPageLayout = ({ children, style, ...restProps }: HTMLAttributes<HTMLDivElement>) => (
  <div
    style={{
      height: '100vh',
      width: '100vw',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      color: 'var(--tuna-palette-text-primary)',
      ...style,
    }}
    {...restProps}
  >
    {children}
  </div>
)
